import * as React from "react";
import Paper from "@material-ui/core/Paper/Paper";
import Typography from "@material-ui/core/Typography/Typography";

export const NotFoundPage = (props: any) => {
    return <Paper style={{ padding: 16, marginTop: 16 }}>
        <Typography variant="h4">The page you were looking for was not found</Typography>
    </Paper>;
}


// WEBPACK FOOTER //
// ./src/pages/not-found-page.tsx